import { render, staticRenderFns } from "./GenericButton.vue?vue&type=template&id=6080343a&scoped=true"
import script from "./GenericButton.vue?vue&type=script&lang=js"
export * from "./GenericButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080343a",
  null
  
)

export default component.exports